module.exports = __webpack_public_path__ + "d67bb365dcfe3a545f75e1eb7ee62c34.png";